import { render } from "./loglist.vue?vue&type=template&id=73a2a892"
import script from "./loglist.vue?vue&type=script&lang=js"
export * from "./loglist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__